import { toOrderLineItem } from '../line-item/order-line-item.js';
import { toDrafts } from '../../server/to-drafts.js';

const toOverviewOrder = (order, intl, options = {})=>{
    var _paymentStatus;
    return {
        drafts: toDrafts(order.lineItems),
        lineItems: order.lineItems.map((lineItem)=>toOrderLineItem(lineItem, intl, options)
        ),
        orderNumber: order.orderNumber,
        orderDate: new Date(order.orderDate),
        paymentStatus: (_paymentStatus = order.paymentStatus) !== null && _paymentStatus !== void 0 ? _paymentStatus : ''
    };
};

export { toOverviewOrder };
//# sourceMappingURL=order-overview.js.map
